export default function Logo({ imgClassName = "h-12 w-auto", compact = false }) {
  return (
    <span className="flex items-center gap-3">
      <img
        src="/logo-amn.png"
        alt="AMN Advocacia"
        className={imgClassName}
        draggable="false"
      />
      {!compact && (
        <span className="leading-tight text-left">
          <span className="font-display block text-lg font-semibold tracking-wide text-cream">
            AMN <span className="gold-text">Advogadas</span>
          </span>
          <span className="font-mono-meta block text-[10px] uppercase tracking-[0.3em] text-mist">
            Consultoria Jurídica
          </span>
        </span>
      )}
    </span>
  );
}
